import React from "react";
import "./Footer.css"

const Footer = () => {
    return (
        <footer>
            <span>Made by </span>
            <a href="http://marcosfraga.ch" target="_blank" rel="noreferrer"><img src="https://mfraga.site/images/novo-logo-W.png" alt="Marcos Fraga" /></a>
        </footer>
    )
};

export default Footer;